import {Component, Inject, Input, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {BaseFormComponent} from 'nc-shared';

@Component({
  selector: 'nc-input',
  templateUrl: './nc-input.component.html',
  styleUrls: ['./nc-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: NcInputComponent, multi: true
  }]
})
export class NcInputComponent extends BaseFormComponent implements OnInit {
  @Input() inline: boolean = false;
  @Input() width?: number;
  @Input() type = 'text';
  @Input() tooltip: string = '';
  @Input() textAlign: string = 'inherit';
  @Input() hint: string = '';
  @Input() maxLength: number;

  @Input() isPhoneNumber: boolean;

  /**
   * imask config object (Any object which extends IMask.AnyMaskedOptions)
   */
  @Input() mask: any;

  /**
   * Possible values (true, false, 'typed').
   * if true returns user input only, false returns whole content of input.
   * 'typed' can be used with typed mask and can return value of specific type (number, date)
   */
  @Input() unmask: boolean | 'typed' = true;

  private PLUS_CODE = 43;
  private ZERO_CODE = 48;
  private NINE_CODE = 57;

  constructor(@Inject('ValidationErrorMap') public errorMap: any) {
    super(errorMap);
    if (this.width === undefined) {
      this.width = this.inline ? 50 : 100;
    }
  }

  phoneNumberPasteFilter() {
    return !this.isPhoneNumber;
  }

  phoneNumberFilter(event, value): boolean {
    if (this.isPhoneNumber) {
      const code = event.keyCode;
      const isPlus = code === this.PLUS_CODE;
      const isNumber = code >= this.ZERO_CODE && code <= this.NINE_CODE;

      if (isPlus && value.length >= 1) {
        return false;
      }

      if (isNumber && value.length === 0) {
        return false;
      }

      if (value.length > 15) {
        return false;
      }

      return isPlus || isNumber;
    }

    return true;
  }

  getNgClasses(): any {
    return {
      'app-form-input-not-inline': this.inline === false
    };
  }

  getNgStyle(): any {
    return {
      width: this.width + '%'
    };
  }
}
